import { Http, chartRequest, customRequest } from './http';
import axios from 'axios';
import { getApigw } from '@/util/index.js';
import { TRACK_ACTIONS, $telescopeEvent } from '@/plugins/telescope';

const apigw = getApigw();

// SCRM添加企业微信环境
const scrmApi = `${location.protocol}//scrm-qa.apigw.qa.91jkys.com/`;
const scrmApigw = location.href.indexOf('qa.91jkys.com') > -1 ? scrmApi : apigw;

const common = {
  basePre: '/drugstore/1.0' // 基础前置路径
};
let mock = true;
mock = false;
const Fetch = {
  login(params) {
    return Http.post(`${common.basePre}/pc_login`, params);
  },
  getAreas: params => customRequest(`${apigw}api/spider-district/1.0/child`, 'get', params), // 获取地区
  // 用户名密码登录
  userLogin(params) {
    return Http.post(`${common.basePre}/pc_user_name_login`, params);
  },
  // 修改密码
  updatePassword(params) {
    return Http.post(`${common.basePre}/change_password`, params);
  },
  logOut() {
    return Http.post(`${common.basePre}/pc_logout`);
  },
  sendVerifyCode(mobile) {
    return Http.post(`${common.basePre}/send_verify_code`, { mobile });
  },
  // 语音验证码
  sendVoiceVerifyCode(mobile) {
    return Http.post(`${common.basePre}/sendVoiceVerifyCode`, { mobile });
  },
  prescriptionList(params) {
    // 获取处方列表
    return Http.post(`${common.basePre}/prescription_page`, params);
  },
  updateChannelStatusYX(params) {
    // 获取处方列表
    return Http.post(`${apigw}api/zy-operation-tcsp/1.0/updateChannelStatus`, params);
  },
  prescriptionDetail(params) {
    return Http.post(`${common.basePre}/prescription_detail`, params);
  },
  // 删除处方
  deletePrescription(params) {
    return Http.post(`${common.basePre}/delete_prescription`, params);
  },
  fetchChatHistory(params) {
    return chartRequest.get(`${common.basePre}im/1.0/netHospital/queryHistoryMsg`, { params });
  },
  getPcListConfig(params) {
    return Http.get(`${common.basePre}/get_pc_list_config`, { params });
  },
  // 门店管理 新增门店
  insert_store(params) {
    return Http.post(`${common.basePre}/addStore`, params);
  },
  // 门店管理页 获取门店详情
  get_store_fromId(params) {
    return Http.get(`${common.basePre}/storeDetail`, params);
  },
  // 获取门店关联监管信息
  get_store_supervision(params) {
    // return Http.post(`/amikacin/1.0/store_supervision`, params);
    return Promise.resolve({});
  },
  // 图片上传接口
  uploadFile(params) {
    return axios({
      method: 'POST',
      url: `${Util.getGwRoot}spider-fileupload/1.0/upload_and_set_upload_info`,
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      data: params
    });
  },
  // 门店管理页 获取门店列表
  get_store_page(params) {
    return Http.get(`${common.basePre}/storePage`, params);
  },
  // 门店管理  更新门店信息
  update_store(params) {
    return Http.post(`${common.basePre}/updateStore`, params);
  },
  // 门店管理  更新门店经纬度
  update_store_location(params) {
    return Http.post(`${common.basePre}/update_shop_longitudeLatitude`, params);
  },
  // 获取职员列表
  getUserPage(params) {
    return Http.get(`${common.basePre}/userPage`, params);
  },
  // 获取当前用户所有相关信息
  getUserAndStoreInfo(params, apiConf) {
    return Http.get(`${common.basePre}/getUserAndStoreInfo`, { ...params, apiConf });
  },
  // 门店管理 设置门店
  updateStoreSetting(params) {
    return Http.post(`${common.basePre}/updateStoreSetting`, params);
  },

  // 新增职员
  addUser(data) {
    return Http.post(`${common.basePre}/addUser`, data);
  },
  // 删除职员
  deleteUser(data) {
    return Http.post(`${common.basePre}/delete_user`, data);
  },
  // 获取职员详情
  getUserDetail(params) {
    return Http.get(`${common.basePre}/userDetail`, params);
  },
  // 门店模糊查询
  getStoreList(params) {
    return Http.get(`${common.basePre}/limitedStoreList`, params);
  },
  // 审核处方
  verifyPrescription(data) {
    // 批量审核也使用该接口
    // return Http.post(`https://mock.qa.91jkys.com/api/project/mock/32/wx_pharmacist_audit_prescription`, data);
    return Http.post(`${common.basePre}/wx_pharmacist_audit_prescription`, data);
  },
  batchDispenseDispatch(data) {
    return Http.post(`${common.basePre}/batch_dispense_dispatch`, data);
  },
  updateUser(data) {
    return Http.post(`${common.basePre}/updateUser`, data);
  },
  can_you_delete_store(data) {
    // 能否删除该店铺
    return Http.post(`${common.basePre}/can_you_delete_store`, data);
  },
  delete_store(data) {
    // 删除该店铺
    return Http.post(`${common.basePre}/delete_store`, data);
  },
  recover_store(data) {
    // 恢复店铺
    return Http.post(`${common.basePre}/recover_store`, data);
  },
  stat_prescription_tendency(data) {
    // 处方趋势统计
    return Http.post(`${common.basePre}/stat_prescription_tendency`, data);
  },
  get_prescription_auditor(data) {
    // 审核过处方的药师
    return Http.post(`${common.basePre}/get_prescription_auditor`, data);
  },
  get_used_drug_list(data) {
    // 开过的药品
    return Http.post(`${common.basePre}/get_used_drug_list`, data);
  },
  stat_prescription_top(data) {
    // 开过的药品
    return Http.post(`${common.basePre}/stat_prescription_top`, data);
  },
  messageCenterList(data) {
    return Http.post(`${common.basePre}/messages_page`, data);
  },
  readMessage(data) {
    return Http.post(`${common.basePre}/read_messages`, data);
  },
  update_user_online_status(data) {
    // 更新用户在线状态
    return Http.post(`${common.basePre}/update_user_online_status`, data);
  },
  have_messages(data) {
    // 获取通知
    return Http.get(`${common.basePre}/have_messages`, { ...data });
  },
  prescription_list_to_deal(data) {
    // 待审核处方列表
    return Http.get(`${common.basePre}/prescription_list_to_deal`, { ...data });
  },
  store_account_info_pc(data) {
    // 获取门店账户信息
    return Http.get(`${common.basePre}/store_coin_info_pc`, { ...data });
  },
  recharge_order(data) {
    // 充值
    return Http.post(`${common.basePre}/recharge_order`, data);
  },
  recharge_money_calculate(data) {
    // 计算兑换比例
    return Http.post(`${common.basePre}/recharge_money_calculate`, data);
  },
  get_recharge_order(data) {
    // 查询订单状态
    return Http.post(`${common.basePre}/get_recharge_order`, data);
  },
  user_recharge_order_page(data) {
    // 获取用户购买 充值点数记录
    return Http.post(`${common.basePre}/user_recharge_order_page`, data);
  },
  store_coin_detail_page(data) {
    // 药店点数消费明细
    return Http.post(`${common.basePre}/store_coin_detail_page`, data);
  },
  update_agreement_sign: agreementId => {
    if (agreementId) {
      return Http.post(`${common.basePre}/agreement_confirm`, { os: navigator.userAgent, agreementId }); // 签署协议
    }
    return Promise.resolve();
  },
  get_agreement_list() {
    // 协议列表
    return Http.get(`${common.basePre}/agreement_list`);
  },
  get_agreement_detail(agreementId) {
    // 协议详情
    return Http.get(`${common.basePre}/agreement_detail`, { agreementId });
  },
  get_biz_check(checkCode) {
    return Http.post(`${common.basePre}/biz_check`, { checkCode });
  },
  // 根据电话获取用户信息
  getUserinfoByMobile(data) {
    return Http.post(`${common.basePre}/get_user_info_by_mobile`, data);
  },
  getUserinfoByNameOrMobile(data) {
    return Http.post(`${common.basePre}/query_patient`, data);
  },
  query_patient_by_id(data) {
    return Http.get(`${common.basePre}/query_patient_by_id`, data);
  },
  has_answer(imGroupId) {
    // 进入IM推送的问题
    return Http.post(`${common.basePre}/has_answer`, { imGroupId });
  },
  submit_answer(params) {
    // 回答推送的问题
    return Http.post(`${common.basePre}/submit_answer`, params);
  },
  cancel_prescription(params) {
    // 主动结束im问诊,参数imGroupId
    return Http.post(`${common.basePre}/cancel_prescription`, params);
  },
  // 查询当前咨询单详情
  get_advisory_info(params) {
    return Http.post(`${common.basePre}/get_advisory_info`, params);
  },
  // 主动结束咨询单
  close_advisory(advisoryId) {
    return Http.post(`${common.basePre}/close_advisory`, { advisoryId });
  },
  // 查询问诊单状态
  getPrescriptionByAdvisoryId(data) {
    return Http.get(`${common.basePre}/getPrescriptionByAdvisoryId`, data);
  },
  // 查询进行中咨询单
  getOpenAdvisoryBSide() {
    return Http.get(`${common.basePre}/getOpenAdvisoryBSide`);
  },
  // 查询是否展示肝肾病
  applyAdvisoryPageInit() {
    return Http.get(`${common.basePre}/applyAdvisoryPageInit`);
  },
  // 查询病历是否需要上传
  checkCaseHistoryUploadRemind(params) {
    return Http.post(`${common.basePre}/checkCaseHistoryUploadRemind`, params);
  },
  // 申请咨询单
  wechat_apply_advisory(params) {
    return Http.post(`${common.basePre}/wechat_apply_advisory`, params, { closeLoading: true });
  },
  // 咨询列表
  getAdvisoryList(data) {
    return Http.get(`${common.basePre}/getAdvisoryList`, data);
  },
  /**
   * @deprecated
   * 没有调用了
   */
  getgroupList(params) {
    // 咨询列表
    return Http.post(`${apigw}/api/chat/2.0/im_group_list `, params);
  },
  /**
   * @deprecated
   * 没有调用了
   */
  // 6岁儿童限制处方-单店查询配置
  getLimitChildSetting(params) {
    return Http.post(`${apigw}/api/drugstore/1.0/get_limit_children_setting`, params);
  },
  // 发送验证码通过key来区分模版
  send_verify_code_by_type(data) {
    return Http.post(`${apigw}api/drugstore/1.0/send_verify_code_by_type`, data);
  },
  // 发送开方语音验证码通过key来区分模版
  send_prescription_voice_verify_code(data) {
    return Http.post(`${apigw}api/drugstore/1.0/send_voice_verify_code_by_type`, data);
  },
  get_drug_option() {
    // 获取药品单位列表
    return Http.post(`${common.basePre}/get_drug_option`);
  },
  drug_setting() {
    // 获取药品单位列表
    return Http.get(`${common.basePre}/drug_setting`);
  },
  get_drug_name({ name, barcode }) {
    // 查询药品
    return Http.post(`${common.basePre}/query_drug`, { name, barcode }, { closeLoading: true });
  },
  save_drug(name, drugProductDTOS) {
    // 更新或者新增药品
    return Http.post(`${common.basePre}/add_or_update_drug`, { name, drugProductDTOS }, { closeLoading: true });
  },
  check_drug(currentDrug, drugList) {
    // 检验更新或者新增药品
    return Http.post(`${common.basePre}/preDrugCheck`, {
      currentDrug,
      drugList
    });
  },
  get_spec(gnuId) {
    // 获取规格
    return Http.post(`${common.basePre}/query_drug_by_gnu_id`, { gnuId }, { closeLoading: true });
  },
  get_drug_limit(params) {
    // 处方单个药品数量限制查询
    return Http.post(`${common.basePre}/query_drug_limit`, params, { closeLoading: true });
  },
  get_symptoms_and_illnesses_tag(drugIds) {
    // 获取病症和诊断tag
    return Http.post(`${common.basePre}/get_symptoms_and_illnesses_tag`, { drugIds }, { closeLoading: true });
  },
  get_last_advisory() {
    // 获取上次处方状态
    return Http.post(`${common.basePre}/last_advisory`);
  },
  apply_prescription(params, config = {}) {
    // 申请处方（发起问诊）
    return Http.post(`${common.basePre}/wx_apply_prescription`, params, config);
  },
  im_prescription(params) {
    // 聊天组的处方状态
    return Http.post(`${common.basePre}/im_prescription`, params);
  },
  get_service_price() {
    // 获取服务点数
    return Http.get(`${common.basePre}/get_service_price`);
  },
  getDoctorDetail(params) {
    return Http.get(`${common.basePre}/app_doctor_detail_v2`, { ...params });
  },
  get_video_doctor_valid_time() {
    return Http.get(`${common.basePre}/get_video_doctor_valid_time`);
  },
  // 获取云信token
  get_yunxin_user_token_need_login(params) {
    return Http.get(`${common.basePre}/get_yunxin_user_token_need_login`, { ...params });
  },
  get_punch_detail() {
    // 获取打卡状态
    return Http.get(`${common.basePre}/get_punch_detail`);
  },
  punch(image) {
    // 上下班打卡
    return Http.post(`${common.basePre}/punch`, { image }, { closeLoading: true });
  },
  before_punch() {
    // 打卡前置检查
    return Http.get(`${common.basePre}/before_punch`);
  },
  punch_page_query(params) {
    // 查询打卡记录
    return Http.post(`${common.basePre}/get_punch_records`, params);
  },
  face_compare(image) {
    // 人脸识别
    return Http.post(
      `${common.basePre}/face_compare`,
      {
        content: image,
        type: 1,
        timestamp: +new Date()
      },
      { closeLoading: true }
    );
  },

  push_ios_voip_message(params) {
    return Http.post(`${common.basePre}/push_ios_voip_message`, params);
  },
  get_leisure_doctors() {
    return Http.get(`${common.basePre}/get_leisure_doctors`);
  },
  // 新的找医生接口，添加参数，因为要兼容老得，后端兼容不了，就重新开一个接口
  get_leisure_doctors_by_query(params) {
    return Http.post(`${common.basePre}/get_leisure_doctors_by_query`, params);
  },
  // 获取当前的活动信息
  get_current_matched_activity(params) {
    return Http.get(`${common.basePre}/get_current_matched_activity`, { ...params, source: 'pc' });
  },
  get_activity_by_id(params) {
    return Http.get(`${common.basePre}/get_activity_by_activity_id`, params);
  },
  export_async_task_query(params) {
    // 下载列表
    return Http.post(`${common.basePre}/export_async_task_query`, params);
  },
  export_async_get_file_url(taskId) {
    // 获取下载链接
    return Http.get(`${common.basePre}/export_async_get_file_url`, { taskId });
  },
  export_prescription_img_async(params) {
    // 批量导出处方图片
    return Http.post(`${common.basePre}/export_prescription_img_async`, params);
  },
  export_prescription_and_emr_img_async(params) {
    // 批量导出处方和电子病历
    return Http.post(`${common.basePre}/export_prescription_and_emr_img_async`, params);
  },
  export_prescription_async(params) {
    // 批量导出处方
    return Http.post(`${common.basePre}/export_prescription_async`, params);
  },
  export_store_async(params) {
    // 批量导出药店列表
    return Http.post(`${common.basePre}/export_store_async`, params);
  },
  export_user_async(params) {
    // 批量导出职员列表
    return Http.post(`${common.basePre}/export_user_async`, params);
  },
  export_prescription_detail_async(params) {
    // 处方详情异步导出
    return Http.post(`${common.basePre}/export_prescription_detail_async`, params);
  },
  get_company_drug_list(searchWords) {
    // 查询公司药品库
    return Http.get(`${common.basePre}/get_company_drug_list`, { searchWords });
  },
  export_async_cancel(taskId) {
    // 导出任务取消
    return Http.post(`${common.basePre}/export_async_cancel`, { taskId });
  },
  queryAreaList(params) {
    // 获取大区列表
    return Http.get(`${common.basePre}/queryAreaList`, { ...params });
  },
  getArea(id) {
    // 获取大区详情
    return Http.get(`${common.basePre}/getArea`, { id });
  },
  limitedStoreForArea(params) {
    // 获取大区
    return Http.get(`${common.basePre}/limitedStoreForArea`, params);
  },
  addArea(params) {
    // 新增大区
    return Http.post(`${common.basePre}/addArea`, params);
  },
  updateArea(params) {
    // 编辑大区
    return Http.post(`${common.basePre}/updateArea`, params);
  }, // 录制视频
  record_video(params) {
    return Http.post(`${common.basePre}/record_video`, { ...params });
  },
  // 获取投放资源
  resource_put_list(params) {
    return Http.get(`${common.basePre}/resource_put_list`, { ...params });
  },
  async_export_store_coin(params) {
    return Http.post(`${common.basePre}/async_export_store_coin`, params);
  },
  print_prescription(prescriptionIds) {
    return Http.post(`${common.basePre}/print_prescription`, {
      prescriptionIds
    });
  },
  photo_advisory_right() {
    return Http.get(`${common.basePre}/photo_advisory_right`);
  },
  // 视频先问走诊
  apply_video_inversion_sequence(data) {
    return Http.post(`${common.basePre}/apply_video_inversion_sequence`, data);
  },
  // 补充药品信息
  append_prescription_details(data) {
    return Http.post(`${common.basePre}/append_prescription_details`, data);
  },
  // 先问后诊的视频查询是否已接通和选药
  check_append_details_and_connected(params) {
    return Http.get(`${common.basePre}/check_append_details_and_connected`, params);
  },
  // 上传图片，直接使用http实例化的axiso，axios会根据参数是否实formData，自动转换
  upload_file(params) {
    return Http.post(`${Util.getGwRoot}spider-fileupload/1.0/upload_and_set_upload_info`, params);
  },
  // 拍照开方
  apply_photo_prescription(params) {
    return Http.post(`${common.basePre}/apply_photo_prescription`, params);
  },
  // 根据gnu获取药品名
  query_gnu_by_name(params) {
    return Http.post(`${common.basePre}/query_gnu_by_name`, params, { closeLoading: true });
  },
  // 查询药品库
  query_company_drug_page(params) {
    return Http.post(`${common.basePre}/query_company_drug_page`, params);
  },
  // 批量导入药品
  importDrugByExcel(params) {
    return Http.post(`${common.basePre}/import_drugs`, params);
  },
  // 导出药品
  exportDrugByExcel(params) {
    return Http.get(`${common.basePre}/export_drugs`, params);
  },
  // 删除药品
  deleteCompanyDrugByBarcodeOrSpuId(params) {
    return Http.post(`${common.basePre}/deleteCompanyDrugByBarcodeOrSpuId`, params);
  },
  // 查询药品
  queryCompanyDrugDetailBySpuId(params) {
    return Http.get(`${common.basePre}/queryCompanyDrugDetailBySpuId`, params);
  },
  // 添加或更新药品
  addOrUpdateCompanyDrug(params) {
    return Http.post(`${common.basePre}/addOrUpdateCompanyDrug`, params);
  },
  // 用户申请的最大的用药天数
  patientApplyMaxDose() {
    return Http.get(`${common.basePre}/patientApplyMaxDose`);
  },

  check_need_id_no(params) {
    return Http.post(`${common.basePre}/check_id_card_validate_white_list`, params);
  },
  // 获取药店审方模式设置
  getStoreAuditModeSetting(params) {
    return Http.get(`${common.basePre}/getStoreAuditModeSetting`, params);
  },
  // 保存药店审方模式设置
  updateStoreAuditModeSetting(params) {
    return Http.post(`${common.basePre}/updateStoreAuditModeSetting`, params);
  },
  updateStorePrescriptionTmpl(data) {
    return Http.post('/drugstore/1.0/update_prescription_template', data);
  },
  // 获取患者信息
  queryPatientInfoByPrescriptionId(prescriptionId) {
    return Http.get(`${common.basePre}/queryPatientInfoByPrescriptionId`, { prescriptionId });
  },
  // 是否是高风险药品
  isHighRiskDrug(params) {
    return Http.get(`${common.basePre}/isHighRiskDrug`, { ...params });
  },
  // 查询药店有无经纬度
  select_store_longitudeLatitude(params) {
    return Http.get(`${common.basePre}/select_store_longitudeLatitude`, params);
  },
  // 校验扫码客户和店铺的距离和白名单
  async check_distance_and_whiteList(params) {
    let res = await Http.get(`${common.basePre}/check_distance_and_whiteList`, params);
    $telescopeEvent({
      trackId: TRACK_ACTIONS.ZYWZPC_AMAP_CHECK_DISTANCE,
      custom: res
    });
    return res;
  },
  // 自动更新经纬度
  auto_update_store_longitudeLatitude(params) {
    return Http.get(`${common.basePre}/auto_update_store_longitudeLatitude`, params);
  },
  // 消息中心列表v2
  messagesPageV2(params) {
    return Http.post(`${common.basePre}/messages_page_v2`, params);
  },
  // 查询续费提醒
  getRenewalNotifyInfo(params) {
    return Http.post(`${common.basePre}/query_renewal_notify_info`, params);
  },
  // 查询是否有续费订单入口
  hasRenewalOrderEntrance() {
    return Http.post(`${common.basePre}/has_renewal_order_entrance`);
  },
  // 查询店铺续费列表
  getRenewalStoreList(params) {
    return Http.post(`${common.basePre}/pc_renewal_store_page_list`, params);
  },
  // 查询年费套餐配置
  getPackageConfig() {
    return Http.post(`${common.basePre}/query_package_config`);
  },
  // 查询订单关联门店列表
  getOrderLinkStoreList(params) {
    return Http.post(`${common.basePre}/order_link_store_page_list`, params);
  },
  // 续费订单详情查询
  getRenewalOrderDetail(params) {
    return Http.post(`${common.basePre}/renewal_order_detail`, params);
  },
  // 续费订单列表
  getRenewalOrderList(params) {
    return Http.post(`${common.basePre}/renewal_order_page_list`, params);
  },
  // 查询登录人对应的销售信息
  getSaleInfo(params) {
    return Http.post(`${common.basePre}/query_sale_info`, params);
  },
  // 是否有待支付续费订单
  hasUnpaidOrder() {
    return Http.post(`${common.basePre}/has_unpaid_order`);
  },
  // 提交续费订单
  submitRenewalOrder(params) {
    return Http.post(`${common.basePre}/submit_renewal_order`, params);
  },
  // 提交支付
  paySubmit(params) {
    return Http.post(`${common.basePre}/pay_submit`, params);
  },
  // 预支付-订单支付状态查询
  queryPayResult(params) {
    return Http.post(`/trade-service/1.0.0/queryPayResult`, params);
  },
  // 取消支付
  payCancel(params) {
    return Http.post(`${common.basePre}/pay_cancel`, params);
  },
  // 查询企业微信基本信
  queryAuthorizedSecret(params) {
    return Http.get(`${scrmApigw}api/drugstore/1.0/queryAuthorizedSecret`, params);
  },
  // 更新企业微信基本配置
  updateAuthorizedSecret(params) {
    return Http.post(`${scrmApigw}api/drugstore/1.0/updateAuthorizedSecret`, params);
  },
  // 批量获取处方笺url
  getImgUrlByPrescriptionIdList(params) {
    return Http.get(`${common.basePre}/get_imgUrlBy_prescriptionIdList`, params);
  },
  // 获取小票图片
  getReceiptPrinting(params) {
    return Http.get('/drugstore/1.0/get_receipt_info', params);
  },
  // 中台统一上传图片
  uploadImage(params) {
    return Http.post('/file/1.0/h5_upload', params);
  },
  get_spec_analysis_info(params) {
    return Http.get(`${common.basePre}/get_spec_analysis_info`, params);
  },
  drug_spec_check(params) {
    return Http.post(`${common.basePre}/drug_spec_check`, params);
  },
  get_drug_machine_result(params) {
    return Http.get(`${common.basePre}/get_drug_machine_result`, params);
  },
  // 拉取聊天信息
  getMessageList(params) {
    return Http.post('/drugstore/1.0/query_message_list', params);
  },
  // 白名单接口
  check_white_list_by_scene(params) {
    return Http.post('/drugstore/1.0/check_white_list_by_scene', params);
  },
  // 批量获取主诉和疾病
  get_symptoms_and_illnesses_diff_drug(params) {
    return Http.post('/drugstore/1.0/get_symptoms_and_illnesses_diff_drug', params);
  },
  // 儿童年龄限制查询
  getChildrenLimitInfo(params) {
    return Http.get(`${common.basePre}/children_limit_info`, params);
  },
  // 医生资质
  getDoctorAptitudeInfo(params) {
    return Http.get('/drugstore/1.0/getDoctorAptitudeInfo', params);
  },
  // 查看医生资质签署协议
  signAgreement4DoctorCert(agreementId) {
    return Http.post('/drugstore/1.0/agreement_confirm_without_role', { os: navigator.userAgent, agreementId });
  },
  // 主诉是否跟随药品，发起申请处方（isSeparateDisplay ： true=跟随；false = 不跟随）
  isSeparateDisplay(params) {
    return Http.post('/drugstore/1.0/is_separate_display', params);
  },
  checkVerifyCodeAndSave(data) {
    return Http.post('/drugstore/1.0/checkVerifyCodeAndSave', data);
  },
  // 创建咨询单预校验
  applyAdvisoryPreCheck(data) {
    return Http.post('/drugstore/1.0/applyAdvisoryPreCheck', data);
  },
  // 是否展示b2b菜单
  isShowB2BEntry() {
    return Http.get('/app_portal/1.0.0/pc-drug-shop-entrance');
  },
  // 获取四类药品销售订单列表
  getSupervisionOrderList(data) {
    return Http.post('/amikacin/1.0/page_wz_drug_order_epi', data);
  },
  // 获取特殊药品销售订单列表
  getSupervisionSpecialOrderList(data) {
    return Http.post('/amikacin/1.0/page_wz_drug_order_nar', data);
  },
  // 获取处方药品销售订单列表
  getSupervisionPrescriptionOrderList(data) {
    return Http.post('/amikacin-prescription/1.0/pc_page_prescription_order_info', data);
  },
  // 划价
  submitPrice(data) {
    return Http.post('/drugstore/1.0/prescription_pricing', data);
  },
  // 获取四类登记记录
  getSupervisionIvList(data) {
    return Http.post('/amikacin/1.0/page_pc_drug_registration', data);
  },
  getSupervisionIvListByDrug(data) {
    return Http.post('/amikacin/1.0/page_wz_drug_det_reg_epi', data);
  },
  getSupervisionSpecialListByDrug(data) {
    return Http.post('/amikacin/1.0/page_wz_drug_det_reg_nar', data);
  },
  // 获取登记记录详情
  getSupervisionIvDetail(data) {
    return Http.post('/amikacin/1.0/query_registration_info_by_id', data);
  },
  // 获取四类药品目录
  getSupervisionCatalogueList(data) {
    return Http.post('/amikacin/1.0/page_query_drug', data);
  },
  // 获取四类药品目录
  getSupervisionSpecialCatalogueList(data) {
    return Http.post('/amikacin/1.0/page_special_drug', data);
  },
  // 是否展示销售订单
  check_amikacin_store() {
    // return Http.get('/amikacin/1.0/amikacin_store_check');
    return Promise.resolve({});
  },
  // 获取统计数据
  statics_drug_order(data) {
    return Http.post('/amikacin/1.0/statics_pc_drug_order_epi', data);
  },
  // 获取特殊药品统计数据
  static_special_drug_order(data) {
    return Http.post('/amikacin/1.0/statics_pc_drug_order_nar', data);
  },
  // 获取处方统计数据
  pc_prescription_order_summary(data) {
    return Http.post('/amikacin-prescription/1.0/pc_prescription_order_summary', data);
  },
  // 查看处方签
  query_prescription_img_url(data) {
    return Http.post('/amikacin-prescription/1.0/pc_query_prescription_img_url', data);
  },
  // 上传处方
  pc_upload_offline_prescription(data) {
    return Http.post('/amikacin-prescription/1.0/pc_upload_offline_prescription', data);
  },
  // 获取药师列表
  getPharmacistIvList(data) {
    return Http.post('/amikacin-pharmacist/1.0/pc_page_pharmacist_info', data);
  },
  // 进销存
  pc_inventory_supervision_sale_summary(data) {
    return Http.post('/amikacin-order/1.0/pc_drug_order_summary', data);
  },
  pc_inventory_supervision_sale_list(data) {
    return Http.post('/amikacin-order/1.0/pc_page_drug_order_info', data);
  },
  pc_inventory_supervision_laid_up_list(data) {
    return Http.post('/amikacin-purchase/1.0/pc_page_purchase_info', data);
  },
  pc_inventory_supervision_laid_up_upload(data) {
    return Http.post('/amikacin-purchase/1.0/pc_upload_purchase', data);
  },
  pc_inventory_supervision_laid_up_summary(data) {
    return Http.post('/amikacin-purchase/1.0/pc_statistic_purchase_info', data);
  },
  pc_inventory_supervision_stock_summary(data) {
    return Http.post('/amikacin-stock/1.0/pc_statistic_stock_info', data);
  },
  pc_inventory_supervision_stock_list(data) {
    return Http.post('/amikacin-stock/1.0/pc_page_stock_info', data);
  },
  // 获取处方药品汇总
  getPrescriptionSummary(data) {
    return Http.post('/amikacin-prescription/1.0/pc_prescription_drug_summary', data);
  },
  // 获取电子处方列表
  getElectronicPrescription(data) {
    return Http.post('/amikacin-prescription/1.0/pc_page_electronic_prescription_info', data);
  },
  // 根据平台名称查询处方平台信息
  getPlatformByName(data) {
    return Http.post('/amikacin-prescription/1.0/query_platform_by_name', data);
  },
  // 获取线下处方列表
  getOfflinePrescription(data) {
    return Http.post('/amikacin-prescription/1.0/pc_page_offline_prescription_info', data);
  },
  // 获取线下处方签URL
  getPrescriptionImageUrl(data) {
    return Http.post('/amikacin-prescription/1.0/pc_query_prescription_img_url', data);
  },
  // 获取处方详情
  getElectronicPrescriptionDetail(data) {
    return Http.post('/amikacin-prescription/1.0/pc_query_electronic_prescription_detail', data);
  },
  // 药监消息轮询
  haveSupervisionMessage(data) {
    return Http.post('/amikacin-message/1.0/pc_have_message', data, { closeLoading: true });
  },
  pushedMessage(data) {
    return Http.post('/amikacin-message/1.0/pushed_message', data);
  },
  // 消息已读
  readSupervisionMessage(data) {
    return Http.post('/amikacin-message/1.0/read_messages', data);
  },
  // 获取消息列表
  getSupervisionMessageList(data) {
    return Http.post('/amikacin-message/1.0/pc_page_message', data);
  },
  // 获取消息列表
  getCorrectionTypeCode(data) {
    return Http.post('/amikacin-config/1.0/query_correction_type', data);
  },
  submitCorrectionNarcotic(data) {
    return Http.post('/amikacin-narcotic/1.0/pc_narcotic_correction_filling', data);
  },
  submitCorrectionPrescription(data) {
    return Http.post('/amikacin-prescription/1.0/pc_prescription_correction_filling', data);
  },
  submitCorrectionEpidemic(data) {
    return Http.post('/amikacin-epidemic/1.0/pc_epidemic_correction_filling', data);
  },
  updateDispenser(data) {
    return Http.post('/drugstore/1.0/update_dispenser', data);
  },
  querySubmitter(data) {
    return Http.post('/drugstore/1.0/query_submitter', data);
  },
  getMerchantAccountList(params) {
    return Http.get(`/o2o_account/1.0.0/merchant_account_list`, { ...params });
  },
  o2oPay(data) {
    return Http.post('/o2o_account/1.0.0/merchant_account_recharge', data);
  },
  getMerchantAccountFlowList(params) {
    return Http.get(`/o2o_account/1.0.0/merchant_account_flow_list`, { ...params });
  },
  getAccountRechargeFlow(params) {
    return Http.get(`/o2o_account/1.0.0/account_recharge_flow`, { ...params });
  },
  getAccountAdjustFlow(params) {
    return Http.get(`/o2o_account/1.0.0/account_adjust_flow`, { ...params });
  },
  getAccountServiceFeeFlow(params) {
    return Http.get(`/o2o_account/1.0.0/account_service_fee_flow`, { ...params });
  },
  getRechargeLimitInfo(params) {
    return Http.get(`/o2o_account/1.0.0/recharge_limit_info`, { ...params });
  },
  // 获取中西药疾病
  queryIllness(data) {
    return Http.post('/drugstore/1.0/queryIllness', data);
  },
  // 药店分页搜索
  queryStorePage(data) {
    return Http.post('/drugstore/1.0/queryStorePage', data);
  },
  // 解绑公司负责人手机
  unbindCompanyManageMobile() {
    return Http.post('/drugstore/1.0/unbind_company_manager_mobile');
  },
  // 获取权限白名单
  whiteListBizCheck(data) {
    return Http.post('/drugstore/1.0/whiteListBizCheck', data);
  },
  getUserSignature() {
    return Http.get('/drugstore/1.0/get_user_signature');
  },
  batchPrintImage(data) {
    return Http.post('/drugstore/1.0/getPrintImg', data);
  }
};

window.Fetch = Fetch;
export default Fetch;
